var render = function () {
  var _vm$program, _vm$program$files;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": "제조지원·교육"
    }
  }), _c('service-navigation-row'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('service-support-category', {
    attrs: {
      "category": _vm.category
    }
  }), _c('service-support-title', {
    attrs: {
      "category": _vm.category
    }
  }), _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    staticClass: "board-table board-table--view",
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    attrs: {
      "role": "rowgroup"
    }
  }, [_c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_c('div', {
    staticClass: "tit-button-wrap"
  }, [_c('div', {
    staticClass: "tit-button__tit"
  }, [_vm._v(" " + _vm._s((_vm$program = _vm.program) === null || _vm$program === void 0 ? void 0 : _vm$program.title) + " ")]), _c('service-support-status', _vm._b({}, 'service-support-status', {
    program: _vm.program
  }, false))], 1)])]), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('ul', {
    staticClass: "board-view-data"
  }, [_c('li', [_vm._v(" 신청기간 : "), _c('span', {
    staticClass: "d-inline-block"
  }, [_vm._v(_vm._s(_vm.applicationDuration))])]), _c('li', [_vm._v(" 지원기간 : "), _c('span', {
    staticClass: "d-inline-block"
  }, [_vm._v(_vm._s(_vm.serviceDuration))])])])])]), (_vm$program$files = _vm.program.files) !== null && _vm$program$files !== void 0 && _vm$program$files.length ? _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('div', {
    staticClass: "board-view-file"
  }, [_c('span', {
    staticClass: "head"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 409 513.6"
    },
    attrs: {
      "version": "1.1",
      "id": "레이어_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 409 513.6",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "d": "M41.5,452.8v-353c0-11,9-20,20-20h60v-19c0-11,9-20,20-20c11,0,20,9,20,20v141c0,11-9,20-20,20c-11,0-20-9-20-20v-82h-40v82\n                                                c0,33.1,26.9,60,60,60c33.1,0,60-26.9,60-60v-122h145.9c11,0,20,9,20,20v353c0,11-9,20-20,20H61.5C50.5,472.8,41.5,463.8,41.5,452.8\n                                                M85.3,39.8H61.5c-33.1,0-60,26.9-60,60v353c0,33.1,26.9,60,60,60h285.9c33.1,0,60-26.9,60-60v-353c0-33.1-26.9-60-60-60H197.7\n                                                c-8.5-22.8-30.5-39-56.2-39S93.9,17,85.3,39.8"
    }
  })]), _vm._v(" 첨부파일 : ")]), _c('ul', {
    staticClass: "lists"
  }, _vm._l(_vm.program.files, function (file) {
    return _c('li', {
      key: file._id,
      staticClass: "ml-20"
    }, [_c('a', {
      attrs: {
        "href": file === null || file === void 0 ? void 0 : file.url,
        "download": ""
      }
    }, [_vm._v(" " + _vm._s(file === null || file === void 0 ? void 0 : file.fileName) + " ")])]);
  }), 0)])])]) : _vm._e(), _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_c('div', {
    staticClass: "board-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.program.content)
    }
  })])])])])]), _c('div', {
    staticClass: "board-buttons d-flex justify-end mt-20 mt-lg-30"
  }, [_c('v-btn', {
    staticClass: "h-lg-40px",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "color-grey"
  }, [_vm._v("List")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "right"
  }, [_c('a', {
    staticClass: "button button--border",
    attrs: {
      "href": ""
    }
  }, [_c('span', [_vm._v("수정")])]), _c('a', {
    staticClass: "button button--border",
    attrs: {
      "href": ""
    }
  }, [_c('span', [_vm._v("답글")])]), _c('a', {
    staticClass: "button button--primary",
    attrs: {
      "href": ""
    }
  }, [_c('span', [_vm._v("삭제")])])])], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }